import { escapeHtml } from "@emkit/builder-core";
export const ALERT_DEFAULTS = {
    variant: "info",
    title: "Heads up",
    message: "This is an alert. Edit its message from the inspector.",
    icon: "ℹ",
    radius: 8,
};
const VARIANTS = {
    info: {
        bg: "#eff6ff",
        border: "#bfdbfe",
        fg: "#1e3a8a",
        iconBg: "#3b82f6",
        defaultIcon: "ℹ",
    },
    success: {
        bg: "#ecfdf5",
        border: "#bbf7d0",
        fg: "#064e3b",
        iconBg: "#10b981",
        defaultIcon: "✓",
    },
    warning: {
        bg: "#fffbeb",
        border: "#fde68a",
        fg: "#78350f",
        iconBg: "#f59e0b",
        defaultIcon: "!",
    },
    danger: {
        bg: "#fef2f2",
        border: "#fecaca",
        fg: "#7f1d1d",
        iconBg: "#ef4444",
        defaultIcon: "✕",
    },
};
export const alertWidget = {
    type: "alert",
    defaultProps: ALERT_DEFAULTS,
    renderHtml(props) {
        const v = VARIANTS[props.variant ?? "info"];
        const icon = props.icon ?? v.defaultIcon;
        const radius = props.radius ?? 8;
        const title = props.title
            ? `<div style="font-weight:600;margin-bottom:4px;font-size:15px">${escapeHtml(props.title)}</div>`
            : "";
        return `<div class="emk-alert emk-alert--${props.variant}" role="alert" style="display:flex;align-items:flex-start;gap:12px;padding:14px 16px;background:${v.bg};border:1px solid ${v.border};color:${v.fg};border-radius:${radius}px;font-family:inherit;font-size:14px;line-height:1.55"><span aria-hidden="true" style="flex-shrink:0;width:24px;height:24px;border-radius:50%;background:${v.iconBg};color:#fff;display:inline-flex;align-items:center;justify-content:center;font-weight:600;font-size:13px">${escapeHtml(icon)}</span><div>${title}<div>${escapeHtml(props.message)}</div></div></div>`;
    },
};
//# sourceMappingURL=alert.js.map